// 🔽 IMPORTS
import React, { useState, useEffect, useRef } from "react";
import { Button } from "../components/ui/button";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { Card, CardContent } from "../components/ui/card";
import BalanceCard from "./BalanceCard";
import Menu from './menu';
import rollercoinBanner from "../assets/images/bannerRollerCoin.gif";
import logoBanner from "../assets/images/new_logo_without_font.png";
import jwtDecode from "jwt-decode";  // Utilisation du package pour décoder le token
import axios from '../axiosInstance';
import ReCAPTCHA from "react-google-recaptcha";
import { FaTelegramPlane, FaFacebookF, FaXTwitter } from "react-icons/fa6";
import HighPerformanceAd from "../components/HighPerformanceAd";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import KpiCards from "../components/KpiCards";
import AdScriptCard from "../components/AdScriptCard";


import { Footer } from "../components/ Footer";

function Toast({ message, type = "error", onClose }) {
  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
      <div className="flex items-center space-x-2">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
      </div>
    </div>
  );
}



// Composant principal de la page Marketplace
export default function Draw({ onLogout }) {
  // 📊 ÉTATS LOCAUX : gestion des données utilisateur
  const [coinz, setCoinz] = useState(0);
  const [options, setOptions] = useState(0);
  const [weeklyProfit, setWeeklyProfit] = useState(0);
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0) // Son propre bénéfice
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCooldown, setIsCooldown] = useState(false); // Pour gérer le cooldown
  const [cooldownTime, setCooldownTime] = useState(null); // Temps restant avant de pouvoir re-cliquer
  const [latestGain, setLatestGain] = useState(0); // Dernier gain du tirage
  const [now, setNow] = useState(Date.now());
  const navigate = useNavigate();
  // const token = localStorage.getItem("token"); // Récupérer le token depuis le localStorage
  const [history, setHistory] = useState([]);
  const [refCode, setRefCode] = useState(""); // Pour afficher le code de parrainage

  const [toast, setToast] = useState({ message: "", type: "" });
  const [userLevel, setUserLevel] = useState(1);
  const [userXP, setUserXP] = useState(0);
  const [xpForNextLevel, setXpForNextLevel] = useState(100);
  // 🔄 MENU UTILISATEUR (icône) : ouverture/fermeture du menu
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);
 
  // V0.7.0
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [countdown, setCountdown] = useState(15);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");

  // 🔓 DÉCONNEXION : appel à la fonction onLogout passée en prop
  const handleLogout = () => {
    onLogout(); // Déconnexion en parent (App.js)
  };

  const showToast = (message, type = "error") => {
	
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
  const isDesktop = () => window.innerWidth >= 768;
  const sponsorLinks = isDesktop()
  ? [
      "https://www.rotate4all.com/ptp/promote-295671", // en premier si desktop
      "https://lltrco.com/?r=mrpika29", 
      "https://spendharassingwarmly.com/up0q1bx6?key=90c3a28610478a7ab3e84f7ed382d670",
      
    ]
  : [
      "https://lltrco.com/?r=mrpika29", // seul lien sur mobile/tablette  
      "https://spendharassingwarmly.com/up0q1bx6?key=90c3a28610478a7ab3e84f7ed382d670"   ,
    ];


  // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API
  const getUserData = () => { 

    axios.get(`/api/user/me`, { withCredentials: true }) 
      .then((response) => {
        const { coinz, options, systemCoinz, weeklyProfit, lastclaim, ref_code, userLevel, user_Xp, xpForNextLevel  } = response.data;
		    
       const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		
		setSelfWeeklyProfit(valeurCalculee);
    setCoinz(coinz);
    setOptions(options);
    setWeeklyProfit(weeklyProfit);
	  setRefCode(ref_code); // Mise à jour de l'état
		setUserLevel(userLevel);
		setUserXP(user_Xp);
		setXpForNextLevel(xpForNextLevel);
		
        if (lastclaim) {
          const lastClaimDate = new Date(lastclaim);
          const now = Date.now();
          const diff = now - lastClaimDate.getTime();
          const cooldown = 3600000 - diff;
		   // console.log(cooldown);

          if (cooldown > 0) {
            setIsCooldown(true);
            const target = now + cooldown;
            setCooldownTime(target);
            localStorage.setItem("cooldownTime", target); // Mise à jour dans localStorage
			// console.log("ICI");
          } else {
            setIsCooldown(false);
            setCooldownTime(null);
            localStorage.removeItem("cooldownTime");
			// console.log("LA");
          }
        } else {
          setIsCooldown(false);
          setCooldownTime(null);
          localStorage.removeItem("cooldownTime");
		  // console.log("PAS LA");
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
        setLoading(false);
      });
  };
  

  // Fonction pour formater le temps restant en minutes et secondes
// Fonction pour formater le temps restant en minutes et secondes
const formatTime = (ms) => {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
};

// Mettre à jour dynamiquement le temps restant
useEffect(() => {
  if (isCooldown && cooldownTime) {
	  
    const interval = setInterval(() => {
      setNow(Date.now()); // Met à jour l'heure actuelle
    }, 1000);

    return () => clearInterval(interval); // Nettoyer l'intervalle quand le cooldown est terminé
  }
}, [isCooldown, cooldownTime]);


 // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API au chargement du composant
useEffect(() => {
  document.title = "Hourly Draw | CoinzUp";
  getUserData();
    
}, []);

// Fonction de tirage horaire
const handleTirage = async () => {
  try {
	
	if (!captchaToken) {
      showToast("Please validate the captcha.", "error");
      return;
    }
    const response = await axios.post(`/api/tirage`, {
      recaptchaToken: captchaToken, userLevel: userLevel, userXP: userXP
    },{ withCredentials: true }    );

    // Récupérer la réponse du serveur
    const { message, coinz, latestReward, referralReward } = response.data;

    // Affichage des résultats avec précision (8 décimales)
    setCoinz(parseFloat(coinz).toFixed(3));  // Affiche le montant total avec 8 décimales
    setLatestGain(parseFloat(latestReward).toFixed(3));  // Affiche le dernier gain avec 8 décimales

    // Affichage du gain du parrain (si applicable)
   //if (referralGain > 0) {
      //console.log(`Votre parrain a gagné ${referralGain} COINZ!`);
      // Ici, tu peux aussi afficher le gain du parrain dans ton interface si nécessaire
    //}

    // Mise à jour du cooldown
    const cooldownTarget = Date.now() + 3600000; // 1h de cooldown
    setCooldownTime(cooldownTarget);
    localStorage.setItem("cooldownTime", cooldownTarget); // Sauvegarde dans localStorage
    setIsCooldown(true); // Active le cooldown
    showToast(`You've won ${latestReward}`, "success");
    // Recharge la page après le tirage
   // window.location.reload();
  } catch (error) {
    showToast(`Drawing error. Please relog to start again`, "error");
    console.error(error.response?.data?.message || error.message);
  }
};

const startDrawSequence = () => {
  if (!captchaToken) {
    showToast("Please validate the captcha.", "error");
    return;
  }

    // Choisir un lien sponsorisé au hasard
    const randomLink = sponsorLinks[Math.floor(Math.random() * sponsorLinks.length)];
    setIframeUrl(randomLink);

  setIsModalOpen(true);
  setShowIframe(true);
  setCountdown(15); // Démarre à 15s

  const interval = setInterval(() => {
    setCountdown(prev => {
      if (prev <= 1) {
        clearInterval(interval);
        // Appel du tirage après le temps
        handleTirage(); 
        setIsModalOpen(false); // Ferme la modale
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
};

  // ⏳ ÉTAT DE CHARGEMENT : affichage d'un message de chargement tant que les données ne sont pas récupérées
  if (loading) return <div>Loading...</div>;

  // 🧱 RENDU UI
  return (
  <>
   <AdScriptCard scriptSrc="//spendharassingwarmly.com/06/24/a0/0624a04d58c0a5ce026b8eb2c26a839e.js" />
    <div className="min-h-screen flex flex-col bg-gray-900 text-white font-sans">

    


      {/* Layout global avec Sidebar */}
      
      <div className="flex flex-1 min-h-[calc(100vh-64px)]">
        {/* Sidebar identique à Dashboard */}
        <Sidebar onLogout={onLogout} />
  
        {/* Main Content */}
        <main className="flex-1 px-4 sm:px-10 py-8 space-y-10 overflow-auto min-w-0">
          <Header title="Hourly Draw" balance={coinz} optionsOwned={options} estimatedWeeklyGain={selfWeeklyProfit}/>
  
          {/* Toast messages */}
          {toast.message && (
            <Toast
              message={toast.message}
              type={toast.type}
              onClose={() => setToast({ message: "", type: "" })}
            />
          )}
  
          {/* Pub principale */}
          <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90} />
    
          {/* Infos Hourly Draw */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow-sm text-gray-300">
            <h2 className="text-lg font-semibold mb-4 text-white">About the Hourly Draw</h2>
            <p className="text-base leading-relaxed">
              The Hourly Draw lets you can earn up to 100 COINZ every hour. Your chances and rewards improve as you increase your user level.
            </p>
            <p className="mt-4">
              Leveling up unlocks higher reward tiers and better earning potential. For more information, visit the <Link to="/levelup" className="underline text-blue-400 hover:text-blue-600">Level Up</Link> page.
            </p>
            <p className="mt-4">
              To understand how the Hourly Draw functions and how rewards are determined, see the <Link to="/howitworks" className="underline text-blue-400 hover:text-blue-600">How It Works</Link> section.
            </p>
          </div>

          {/* Subtle and elegant leaderboard news block */}
        <div className="bg-gray-800 border border-gray-700 rounded-lg p-5 mt-6 shadow-md">          <div className="flex items-center space-x-2 mb-2">
           
            <h3 className="text-lg font-semibold text-white flex items-center gap-2">
              Weekly Leaderboard Bonus
              
            </h3>
          </div>
          <p className="text-gray-300 text-sm md:text-base">
            Every week, rank in the <strong>top 15</strong> to earn <strong>extra COINZ</strong>!  
            An exclusive bonus for the most dedicated players.
          </p>
          <p className="mt-1 text-yellow-300 text-sm">
            Track your progress and climb the leaderboard to unlock even bigger rewards.
          </p>
          <Link
            to="/leaderboard"
            className="inline-block mt-3 px-4 py-2 rounded bg-yellow-500 text-gray-900 font-semibold hover:bg-yellow-400 transition"
          >
            View Leaderboard
          </Link>
        </div>

          {/* Tirage en cours */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow-sm text-center">
            <h2 className="text-lg font-semibold mb-2 text-white">Hourly Draw Available</h2>
            <p className="text-gray-400 mb-4">
              {latestGain > 0
                ? ` You won ${latestGain} COINZ!`
                : isCooldown
                  ? `Wait ${formatTime(cooldownTime - now)} before playing again.`
                  : `Click below to try and win a bonus!`
              }
            </p>
  
            {!isCooldown && (
              <>
                              
                <div className="flex justify-center items-center mb-4">
                  <ReCAPTCHA
                    sitekey="6LeRXTErAAAAABw214tL2nCwxDvCJ-EKAfoAkUSg"
                    ref={recaptchaRef}
                    onChange={(token) => setCaptchaToken(token)}
                  />
                </div>
              </>
            )}
  
            <Button
               onClick={startDrawSequence}
              className="bg-blue-600 hover:bg-blue-700 font-semibold"
              disabled={isCooldown}
            >
              Start Draw
            </Button>
          </div>
  
          {/* Pub secondaire */}
          <HighPerformanceAd keyId="96e99453a24be0353f2fe26dc0b9b728" width={468} height={60} />
        </main>
      </div>
  
      {/* Footer identique à Dashboard */}
      <Footer />
    </div>

    {isModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
    <div className="relative bg-gray-900 w-[90%] h-[85%] rounded-xl overflow-hidden shadow-2xl">

    <button
        className="absolute top-4 right-4 text-white text-2xl z-10"
        onClick={() => setIsModalOpen(false)}
      >
        ×
      </button>

      <div className="absolute top-0 left-0 right-0 px-6 py-4 bg-gray-900 z-10">
        <h2 className="text-xl font-bold text-white">Please wait…</h2>
        <p className="text-sm text-gray-400">Your reward will be available in <strong>{countdown}s</strong></p>
      </div>

      <iframe
        src={iframeUrl}
        title="Ad or Video"
        className="absolute top-16 bottom-0 left-0 right-0 w-full h-[calc(100%-4rem)] border-none"
      />
    </div>
  </div>
)}
</>
  );
  
}
